import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

import { applyConsentDefaults } from "./utils/analyticsConsent";

// Set Consent Mode defaults as early as possible.
// With your GA snippet in public/index.html, window.gtag is already defined here.
applyConsentDefaults();
console.log("NODE_ENV =", process.env.NODE_ENV);

// Dev-only: silence benign ResizeObserver loop warnings that CRA dev overlay can treat as runtime errors
if (process.env.NODE_ENV === "development") {
  const isResizeObserverWarning = (value) => {
    const msg = String(value ?? "");
    return (
      msg.includes("ResizeObserver loop completed with undelivered notifications") ||
      msg.includes("ResizeObserver loop limit exceeded") ||
      msg.includes("ResizeObserver loop completed")
    );
  };

  // 1) Filter the common CRA overlay trigger path: console.error
  const originalConsoleError = console.error;
  console.error = (...args) => {
    if (isResizeObserverWarning(args?.[0])) return;
    originalConsoleError(...args);
  };

  // 2) Also swallow it if surfaced as a window error (some environments do this)
  const originalOnError = window.onerror;
  window.onerror = function (message, source, lineno, colno, error) {
    if (isResizeObserverWarning(message)) return true;
    if (typeof originalOnError === "function") {
      return originalOnError.apply(this, arguments);
    }
    return false;
  };

  // 3) Capture-phase error listener as an additional guard (prevents propagation to overlays)
  window.addEventListener(
    "error",
    (e) => {
      if (isResizeObserverWarning(e?.message)) {
        e.preventDefault?.();
        e.stopImmediatePropagation?.();
      }
    },
    true
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
